import { MERGE_PLUGINS } from "data/MergeStore";
import SuperRecordStore from "data/SuperRecordStore";
import TableStore from "data/TableStore";
import StereotypesStore from "data/StereotypesStore";
import entityMetaStore from "data/meta/entityMetaStore";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import LoadObject from "data/LoadObject";

export const getAutoMergeExclusions = (ep) => {
    // this function builds an array of fields to exclude from auto merge
    // for use with self to self mapping.
    const entityInfo = entityMetaStore.getInfo(ep.entityKey);
    const entityFieldInfos = entityFieldMetaStore.getAllInfos(entityInfo.key);
    const exclude = [];
    // Find all fields that are not enabled multivalve compositions &
    // auto-manage and exclude them...
    entityFieldInfos.filter((fi) =>
        !(fi.type === "CompositionField"
        && fi.autoManageKey == null
        && ep.isFieldEnabled(fi))
    )
    .forEach((fi) => {exclude.push(fi);});
    return exclude;
};

export const getAutoMergeInclusions = (ep) => {
    // this function builds an array of fields to include from auto merge
    // for use with self to self mapping.
    const entityInfo = entityMetaStore.getInfo(ep.entityKey);
    const entityFieldInfos = entityFieldMetaStore.getAllInfos(entityInfo.key);
    const include = [];
    // Find all fields that are not enabled multivalve compositions &
    // auto-manage and includes them...
    entityFieldInfos.filter((fi) =>
        (fi.type === "CompositionField"
            && fi.autoManageKey == null
            && ep.isFieldEnabled(fi))
    )
        .forEach((fi) => {include.push(fi);});
    return include;
};


export const getAutoMergeGlobalSummary = (sp) => {
    const sourceChildren = [];
    // return records being moved
    const stereoInfo = StereotypesStore.getStereotypeByKey(sp.stereoKey);
    const srInfo = SuperRecordStore.getRecord(
        sp.stereoKey,
        sp.id,
    );

    // all ComositionFields
    stereoInfo.implementations.forEach((it) => {
        const ep = TableStore.getEntityProxy(it.key, sp.id);
        getAutoMergeInclusions(ep).forEach((fi) => {
            const items = ep.get(fi.key);
            if(Array.isArray(items) && items.length) {
                sourceChildren.push({
                    label: fi.name,
                    items: items.map((r) => r.getLabel())
                });
            }
        });
    });

    // all children
    if (srInfo.topLevelIds != null) {
        const labels = [];
        for (const mck of Object.keys(srInfo.topLevelIds)) {
            for (const id of srInfo.topLevelIds[mck]) {
                TableStore.getEntityProxy(mck, id);
                const ep = TableStore.getEntityProxy(mck, id);
                labels.push(ep.getLabel());
            }
        }
        if (labels.length > 0) {
            const childInfo = StereotypesStore.getStereotypeByKey(
                stereoInfo.magicChildKey);
            sourceChildren.push({
                label: labels.length === 1
                    ? childInfo.name
                    : childInfo.pluralName,
                items: labels
            });
        }
    }
    return sourceChildren;
};

export const getAutoMergeRecordSummary = (ep) => {
    const sourceChildren = [];
    const childFields = getAutoMergeInclusions(ep);
    childFields.forEach((field) => {
        const labels = [];
        const records = ep.get(field.key);
        records.forEach(r => {
            labels.push(r.getLabel());
        });
        if(labels.length > 0) {
            sourceChildren.push({
                label: field.name,
                items: labels,
            });
        }
    });
    return sourceChildren;
};


const getInitialGlobalMergeQueue = (targetSP, sourceSP) => {
    const queue = [];
    const stereoInfo = StereotypesStore.getStereotypeByKey(targetSP.stereoKey);
    stereoInfo.implementations.forEach((it) => {
        queue.push({
            target: TableStore.getEntityProxy(it.key, targetSP.id), // these should exist already
            source: TableStore.getEntityProxy(it.key, sourceSP.id)
        });
    });
    return queue;
};

export const processAutoMergeGlobalMappingState = (state = {}) => {
    let newQueue;
    if(state.queue === undefined) {
        // Initial call build the queue.
        const mergeState = {...state};
        newQueue = getInitialGlobalMergeQueue(mergeState.target, mergeState.source);
    }
    else {
        // otherwise use the existing queue
        newQueue = [...state.queue];
    }

    if(!newQueue.length) {
        // mapping workflow should stop before we get here
        throw Error("Attempting to process empty queue.");
    }

    // get the first
    const first = newQueue.shift();

    // start from scratch
    return {
        active: true,
        interactive: state.interactive || false,
        target: first.target,
        source: first.source,
        // don't maintain the promise...
        modelLO: LoadObject.withValue(null),
        drawerOpen: false,
        exclusions: state.exclusions || {},
        queue: newQueue,
        processQueueCallback: processAutoMergeGlobalMappingState,
    };
};

export const buildMappingStateFromMergeState = (mergeState) => {
    const plugin = mergeState.pluginKey;
    switch(plugin) {
        case MERGE_PLUGINS.GLOBAL_MERGE:
            // Global mergeState uses stereotype proxies for the source and
            // target instead of entity proxies. We need to convert the
            // merge state into a queue of mapping states.
            return processAutoMergeGlobalMappingState(mergeState);
        case MERGE_PLUGINS.RECORD_MERGE:
            // Record and child level merges are already entity proxies.
            return {
                active: true,
                interactive: mergeState.interactive || false,
                target: mergeState.target,
                source: mergeState.source,
                // don't maintain the promise...
                modelLO: LoadObject.withValue(null),
                drawerOpen: false,
                exclusions: mergeState.exclusions || {},
            };
        default:
            throw Error(`Unknown merge plugin "${plugin}"`);
    }
};




// WEBPACK FOOTER //
// ./app/data/util/merge/mergeHelpers.js